export default __webpack_public_path__ + "static/media/BlogWrite.652aef92.gif";